import { render, staticRenderFns } from "./NotesTooltip.vue?vue&type=template&id=229b83af&"
import script from "./NotesTooltip.vue?vue&type=script&lang=ts&"
export * from "./NotesTooltip.vue?vue&type=script&lang=ts&"
import style0 from "./NotesTooltip.vue?vue&type=style&index=0&id=229b83af&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports